<div class="absolute z-50 left-1/2 top-1/2 transform -translate-1/2" [ngClass]="{ 'bg-gray-50/70 p-20 rounded-2xl': hasBackground }">
    <div class="flex flex-col gap-5 items-center">
        <p-progress-spinner styleClass="geek-spinner" ariaLabel="loading" [style]="{ width: '80px', height: '80px' }" />
    </div>
</div>
